import "./App.css";
import IntroLivjnSite from "./pages/IntroLivjnConnected";
import IntroLivjnPartner from "./pages/IntroLivjnPartner";
import IntroLivjnUsers from "./pages/IntroLivjnUser";
import IntroOdijn from "./pages/IntroOdijn";

function App() {
  return <IntroLivjnSite />;
}

export default App;
